export interface GaugeStatus {
  label: string;
  badgeClass: string;
  gaugeColor: string;
}

export function clampPercent(value: number): number {
  const n = Number(value);
  if (isNaN(n)) {
    return 0;
  }
  return Math.max(0, Math.min(100, n));
}

export function formatPercent(value: number, decimals: number = 1): string {
  const n = clampPercent(value);
  const factor = Math.pow(10, decimals);
  const rounded = Math.round(n * factor) / factor;
  if (decimals <= 1 && Number.isInteger(rounded)) {
    return `${rounded}%`;
  }
  return `${rounded.toFixed(decimals)}%`;
}

export function formatPercentPrecise(value: number): string {
  const n = Number(value);
  if (isNaN(n)) {
    return '0%';
  }
  const rounded = Math.round(n * 100) / 100;
  if (Number.isInteger(rounded)) {
    return `${rounded}%`;
  }
  const asOne = Math.round(n * 10) / 10;
  if (Math.abs(rounded - asOne) < 0.001) {
    return `${asOne.toFixed(1)}%`;
  }
  return `${rounded.toFixed(2)}%`;
}

export function gaugeStatus(percent: number): GaugeStatus {
  const p = clampPercent(percent);
  if (p <= 0) {
    return { label: 'Not Started', badgeClass: 'is-neutral', gaugeColor: '#d1d5db' };
  }
  if (p < 40) {
    return { label: 'At Risk', badgeClass: 'is-risk', gaugeColor: '#f59e0b' };
  }
  if (p < 80) {
    return { label: 'On Track', badgeClass: 'is-track', gaugeColor: '#2563eb' };
  }
  return { label: 'Excellent', badgeClass: 'is-excellent', gaugeColor: '#2563eb' };
}

export function barTone(percent: number): string {
  const p = clampPercent(percent);
  if (p <= 0) {
    return 'is-empty';
  }
  if (p < 40) {
    return 'is-risk';
  }
  if (p < 80) {
    return 'is-watch';
  }
  return 'is-good';
}

export function categoryDisplayName(categoryName: string): string {
  if (categoryName === 'MTL MOC' || categoryName === 'Task List MOC') {
    return 'MOC';
  }
  return categoryName;
}

export function formatStamp(date: Date, withBullet: boolean = false): string {
  if (!date) {
    return '';
  }
  const day = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  return withBullet ? `${day} • ${time}` : `${day} ${time}`;
}
